/**
 * Created by rafael on 10.03.17.
 */
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import logoinspire from '../../MapHeader/img/logo-inspire.png';
import s from '../../MapHeader/MapHeader.scss';
import { connect } from 'react-redux';

// var Welcome = (props) => {
class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      godzina: 0,
      miesiac: 0,
      doba: 0
    }
  }

  componentDidMount() {
    let url = `${process.env.OLD_IHUB}/get/cieszanow`;
    fetch(url, {
      method: 'GET'
    })
    .then(r => {
      return r.json();
    })
    .then(resp => {
      this.setState({
        godzina: resp.godzina,
        miesiac: resp.miesiac,
        doba: resp.doba
      })
    })
  }

  render() {
    return (
      <div className={'navPopups col-sm-3 panel panel-default absolute-popup'}>
        <div className={'panel-heading'}>Informacje o Autorze
          <img style={{float: "right"}} alt="X Button" className="xbutton" src={this.props.xbutton} onClick={this.props.onInfoClick}/>
        </div>
        <div className={'panel-body'}>
          <a href="http://mapa.inspire-hub.pl/"
            target="_blank">
            <img
              src={logoinspire}
              alt="Logo Inspire"
              style={{ marginTop: '20px', marginBottom: '40px' }}
            /></a><br/>
          Inspire-hub 2 v1.0<br />
          Copyright © 2018 GIAP Sp. z.o.o<br />
          All rights reserved<br />
          <a href="https://giap.pl/"
            target="_blank">https://giap.pl/</a>
          <hr />
          {this.props.prefix == 'gmina_cieszanow' ? 
          <div>
            <h2>Liczba odsłon</h2>
            Aktualna godzina: {this.state.godzina}<br />
            Dzisiaj: {this.state.doba}<br />
            Bieżący miesiąc: {this.state.miesiac}<br />
          </div>
          : null}

          {[
              'gmina_siekierczyn',
              'gmina_strzegom',
              'gmina_swierzawa',
              'gmina_zarow',
              'jawor',
              'swiebodzice'
            ].includes(this.props.district.prefix)
            ? <img src="http://mapa.inspire-hub.pl/static/rpo_dolnoslaskie.png" 
              height={50} width={350} alt="Logo RPO" />
            : null
          }
        </div>
      </div>
    )
  }
  
};

const mapState = (state) => ({
  district: state.district.district
});

const mapDispatch = {};


export default withStyles(s)(connect(mapState, mapDispatch)(Welcome));


// WEBPACK FOOTER //
// src/components/Modals/Welcome/Welcome.js